import { useApiGet } from '@sierralabs/core-ui';
export function useFindFileById(id, version) {
    const url = `files/${id}`;
    const versionQuery = typeof version !== 'undefined' ? `?version=${version}` : '';
    return useApiGet(url + versionQuery);
}
//# sourceMappingURL=useFindFileById.js.map